<script>
	import Button from './Button.svelte';
    export let keyboardType = 'en';
    let keyboards = {
        'en': [
            'qwertyuiop',
            '  asdfghjkl',
            '    zxcvbnm'
        ],
        'he': [
            'קראטוןםפ',
            '  שדגכעיחלךף',
            '    זסבהנמצתץ'
        ]
    }
    let keyboard;
    export let keyboardStatus;
    export let keyPressed;

    function setupKeyboard() {
        console.log('setupKeyboard');
        keyboard = keyboards[keyboardType];
        for (let i = 0; i < keyboard.length; i++) {
            let row = keyboard[i];
            for (let j = 0; j < row.length; j++) {
                // console.log(row[j]);
                keyboardStatus[row[j]] = 'enabled';
            }
        }
    }

    setupKeyboard()
</script>

    <div>
        {#each keyboard as row}
            <div>
                {#each row as btn}
                    {#if btn == ' '}
                      &nbsp;
                    {:else}
                       <Button name={btn} status={keyboardStatus[btn]} keyPressed={keyPressed} />
                    {/if}
                {/each}
            </div>
        {/each}
    </div>
